<div class="dialog-header" fxLayout="row" fxLayoutAlign="start center">
  <span class="dialog-title" fxFlex>Activist Note</span>
  <button mat-icon-button *ngIf="viewMode === 'view'" [matMenuTriggerFor]="dialogActionMenu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #dialogActionMenu="matMenu">
    <button mat-menu-item (click)="viewMode = 'edit'">
      <span>Edit Note</span>
    </button>
    <button mat-menu-item (click)="delete(review)">
      <span>Delete Note</span>
    </button>
  </mat-menu>
</div>
<div mat-dialog-content>
  <ng-container *ngIf="viewMode === 'view'">
    <p><b>Title: </b>{{review.title}}</p>
    <p><b>Prepared By: </b>{{review.prepared_by}}</p>
    <p><b>Date Submitted: </b>{{review.date_sent | date: 'short'}}</p>
    <div><span class="header">Note Content</span></div>
    <p>{{review.content}}</p>
    <div fxLayout="row" fxLayoutAlign="end">
      <button mat-flat-button mat-dialog-close color="warn">Close</button>
    </div>
  </ng-container>
  <div *ngIf="viewMode === 'edit'" class="row" [formGroup]="reviewForm">
    <mat-form-field style="width: 100%;">
      <mat-label>Title</mat-label>
      <input matInput type="text" formControlName="title">
    </mat-form-field>
    <mat-form-field style="width: 100%;">
      <mat-label>Prepared By</mat-label>
      <input matInput type="text" formControlName="prepared_by" [matAutocomplete]="staffOptionsAuto">
    </mat-form-field>
    <mat-autocomplete autoActiveFirstOption #staffOptionsAuto="matAutocomplete">
      <mat-option *ngFor="let option of staffOptionsResults" [value]="option">
        <span>{{option}}</span>
      </mat-option>
    </mat-autocomplete>
    <mat-form-field style="width: 100%;">
      <mat-label>Note</mat-label>
      <textarea matInput type="text" formControlName="content" style="height: 200px;"></textarea>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
      <button mat-flat-button mat-dialog-close color="warn">
        <span>Cancel</span>
      </button>
      <button mat-flat-button [disabled]="reviewForm.pristine"
              color="primary" (click)="save(reviewForm.value)">
        <span>Save</span>
      </button>
    </div>
  </div>
</div>